export default "__VITE_ASSET__2SooLF34__"